import React, { memo } from 'react';
import NewLine from '../NewLine';
import { AddressFormats } from '../../../../../../Enums/AddressFormats';

const FormattedAddress = ({ address }) => {
  return (
    <>
      {address && (
        <p>
          <NewLine list={[address.format]} />
          <NewLine list={[address.careOf?.prefix, address.careOf?.name]} />

          {address.format === AddressFormats.Street ? (
            <>
              <NewLine list={[address.streetName, address.houseNumber, address.houseLetter, address.apartmentNumber]} />
              <NewLine list={[address.additionalAddress]} />
            </>
          ) : address.format === AddressFormats.Foreign ? (
            <>
              <NewLine list={[address.addressLine1]} />
              <NewLine list={[address.addressLine2]} />
              <NewLine list={[address.addressLine3]} />
            </>
          ) : address.format === AddressFormats.FreeText ? (
            <>
              <NewLine list={[address.additionalAddress]} />
            </>
          ) : address.format === AddressFormats.POBox ? (
            <>
              <NewLine list={[address.number, address.facilityName]} />
            </>
          ) : (
            <>
              <NewLine list={[address.addressLine1]} />
              <NewLine list={[address.addressLine2]} />
              <NewLine list={[address.addressLine3]} />
            </>
          )}

          {address.format === AddressFormats.Foreign ? (
            <NewLine list={[address.country?.name, address.city]} />
          ) : (
            <NewLine list={[address.country?.name, address.city, address.postalCode]} />
          )}
        </p>
      )}
    </>
  );
};

export default memo(FormattedAddress);
